import React from "react";

import styles from "./ImageUploader.module.scss";

export const UploaderContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.uploaderContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const UploaderHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.uploaderHeader} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const ButtonsBox: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.buttonsBox} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Divider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.divider} ${className ?? ""}`} {...rest} />
);

export const ImageBox: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.imageBox} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  className,
  alt = "",
  ...rest
}) => (
  <img className={`${styles.image} ${className ?? ""}`} alt={alt} {...rest} />
);
